import { Box, Button, Checkbox, Heading, Image, Input,  Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { useContext } from 'react'
import { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { AuthContext } from '../Context/AuthContext'

function Signup() {
    const {signup,getData,data} = useContext(AuthContext)
    const [formData, setFormData] = useState([])
    const navigate = useNavigate()
    function onChange(e){
        const {value,name} = e.target
        setFormData({
            ...formData,
            [name]:value
        })
    }
    
    function onSubmit(formData){
        const {email,password,username} = formData
        console.log(true)
       
        if( email && password && username){
             signup(email,password,username) 
             navigate("/login")
             alert("sigup Successfully Completed") 
        }else{
            alert("Please enter credentials")
        }
       
        getData()
        console.log(data);
    }
  return (
    <>
        <Box display="flex" >
            <Box w="45%" >
                <Box p="1rem">
                    <Image width="40px" src="https://login.mailchimp.com/release/1.1.14755132428b167ac51d3dc2cf031432a938dbfb5/images/brand_assets/logos/mc-freddie-dark.svg"/>
                </Box>
                <Box  m="1rem 0rem 4rem 8rem" textAlign="left" >
                    <VStack spacing={6} align="stretch">
                        <Heading fontWeight="400">Sign up for Mailchimp</Heading>
                        <Text>Create a free account or <Button variant="link" colorScheme="teal"><NavLink to="/login">log in</NavLink></Button></Text>
                        <Box textAlign="left">
                            <label style={{fontWeight:"bold"}}>
                                Email
                                <Input name="email" type="email"  onChange={onChange} value={formData.email} mt="10px" borderColor="black"  />
                            </label>
                        </Box>
                        <Box textAlign="left">
                            <label style={{fontWeight:"bold"}}>
                                Username
                                <Input name="username" type="text" onChange={onChange}  value={formData.username} mt="10px" borderColor="black"  />
                            </label>
                        </Box>
                        <Box textAlign="left">
                            <label  style={{fontWeight:"bold"}}>
                                Password
                                <Input  name="password" type="password" onChange={onChange}  value={formData.password} mt="10px" borderColor="black"/>
                            </label>
                        </Box>
                        <Box >
                            <Checkbox size="md"  textAlign="left" borderColor="teal" >I don't want to receive emails about Mailchimp and related Intuit product and feature updates, marketing best practices, and promotions from Mailchimp. </Checkbox>
                        </Box>
                        <Text>By creating an account, you agree to our <Button variant="link" textDecoration="underline" colorScheme="teal">Terms</Button> and have read and acknowledge the <Button variant="link" textDecoration="underline" colorScheme="teal">Global Privacy Statement.</Button></Text>
                        <Box>
                            <Button onClick={()=>onSubmit(formData)} variant="solid" colorScheme="teal" color="white" >Sign Up</Button>
                        </Box>
                    </VStack>
                </Box>
                <Text fontSize="14px" textAlign="left">©2001–2022 All Rights Reserved. Mailchimp® is a registered trademark of The Rocket Science Group, LLC. Cookie Preferences, Privacy, and Terms.</Text>
            </Box>
            <Box  w="55%">
                <Image width="100%" height="100%"src="https://user-images.githubusercontent.com/99709824/180266390-ecc22102-a2b3-4666-a80a-257120bbc224.png"/>
            </Box> 
        </Box>        
    </>
  )
}

export default Signup
